import JourneyPromoteColor from './JourneyPromoteColour.svg';
import JourneyPromoteDark from './JourneyPromoteDark.svg';
import JourneyPromoteLight from './JourneyPromoteLight.svg';
export const journeyPromote = { color: JourneyPromoteColor, dark: JourneyPromoteDark, light: JourneyPromoteLight };
//# sourceMappingURL=index.js.map